export type LoadingStatus = 'loading' | 'success' | 'error' | null;